module.exports = __webpack_public_path__ + "media/v2/components/blocks/IconGame/shared/img/survivor/touchdawn-f71cb68f2aebd2a0cedb888f00c45c93.svg";